import React from 'react'
import "../Styles/SectionMid.css";

function SectionMid() {
  return (
    <div>
        <h1 id='mid-sec-h1'>What Customers Have To Say About Us</h1>
    </div>
  )
}

export default SectionMid